var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"timer"},[_c('TimerImage',{staticClass:"timer__img"}),_c('div',{staticClass:"timer__label"},[_c('span',[_vm._v(_vm._s(_vm._f("formatTime")(_vm.hours))+":"+_vm._s(_vm._f("formatTime")(_vm.minutes))+":"+_vm._s(_vm._f("formatTime")(_vm.seconds)))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }